<template>
  <div class="videoPlay" v-if="videoPath!=''"><span class="closePlay" @click="close">关闭</span>
    <div class="vpwrap">
      <video controls="controls" controlslist="nodownload" webkitplaysinline="true" playsinline="true" autoplay="" name="media" :src="videoPath"></video>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  props:{
    videoPath:String,
  },
  methods:{
    close(){
      this.$emit('clearPath', '')
    }
  }
}
</script>

<style scoped lang="less">
.videoPlay{position:fixed;left:0;right:0;top:0;bottom:0;background:#000;z-index:100;overflow:hidden;
  .closePlay{position:fixed;left:15px;top:15px;color:#fff;z-index:1;font-size:14px;cursor:pointer;}
  .vpwrap{width:100%;height:100%;display:flex;color:#fff;justify-content:center;align-items:center;
    video{width:100%;margin-top:50px;}
  }
}
@media (min-width:769px){
  .videoPlay .vpwrap{width:600px;position:relative;left:50%;margin-left:-300px;}
}
</style>



// WEBPACK FOOTER //
// src/components/public/VideoPlay.vue